import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  HttpClient,
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app.routes';
 
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../environments/environment';
import { ENVIRONMENT_TOKEN } from './core/data-access/http/http.service';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { loaderInterceptor } from './core/interceptors/loader.interceptor';
import { NetworkConnectionInterceptor } from './core/interceptors/network-connection.interceptor';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { LIBRARY_CONFIG } from '@cloud4rain_c4r/digital-library';
import { provideStore } from '@ngrx/store';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "/i18n/", ".json");
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ENVIRONMENT_TOKEN, useValue: environment },
    { provide: LIBRARY_CONFIG, useValue: environment.libraryConfig },
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideClientHydration(),
    provideAnimations(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([
        loaderInterceptor,
        tokenInterceptor,
        NetworkConnectionInterceptor,
        ErrorInterceptor,
      ]),
    ),
    provideStore(),
  ],
};
